export default "__VITE_ASSET__e582dd7b__"